<div class="max-w-comfort">
  <p-card>
    <div class="mx-6 my-4">
      <app-patient-info-input title='Myopic Progression' [name]="patientName"
        [ageAtVisit]="calculationResults.serCalcResponse.ethnicities[0].decimalAge" [dateOfLastVisit]="calculationResults.serCalcResponse.ethnicities[0].dateAtLastVisit"></app-patient-info-input>
      @if (reportType === ReportType.ECP && calculationResults.ageWarning) {
      <div class="mb-4">⚠️ {{ 'AGE_WARNING' | translate }}</div>
      } @if (reportType === ReportType.Parent) {
      <div class="horiz-bar bg-primary"></div>
      <app-parent-paragraph [retestMonths]="9" [parentParagraphType]="ParentParagraphType.WHAT_IS_MYOPIA"
        class="mb-6"></app-parent-paragraph>
      <div class="mb-4"></div>
      } @if(reportType === ReportType.ECP){
      <app-myopia-progression [ethnicity]="currentEthnicity" (ethnicityChanged)="onEthnicityChange($event)"
        [myopeProgressionResults]="calculationResults.myopeProgressionResults"
        [calculationResults]="calculationResults"></app-myopia-progression>
      }
      <app-population-comparison class="mt-6" [serCalcResponse]="calculationResults.serCalcResponse"
        [axialCalcResponse]="calculationResults.axialCalcResponse"
        [treatmentCalcResponse]="calculationResults.treatmentCalcResponse" [ethnicity]="currentEthnicity"
        (ethnicityChanged)="onEthnicityChange($event)"></app-population-comparison>

      @if(calculationResults.treatmentCalcResponse.treatmentItems.length > 0 && reportType === ReportType.ECP) {
      <app-myopia-treatments [treatmentCalcResponse]="calculationResults.treatmentCalcResponse"></app-myopia-treatments>
      } @if(reportType === ReportType.Parent) {
      <app-parent-paragraph [retestMonths]="9"
        [parentParagraphType]="ParentParagraphType.HOW_DO_MY_CHILDS_RESULTS_COMPARE_MYOPIC"></app-parent-paragraph>
      <div class="horiz-bar bg-primary mt-4"></div>
      <app-parent-paragraph [retestMonths]="9"
        [parentParagraphType]="ParentParagraphType.WHY_DOES_EYE_SIZE_MATTER"></app-parent-paragraph>
      @if(hasActiveTreatment){
      <app-parent-paragraph [retestMonths]="9"
        [parentParagraphType]="ParentParagraphType.SLOWDOWN_MYOPIA_MYOPIC_WITH_TREATMENT"></app-parent-paragraph>
      } @else(){
      <app-parent-paragraph [retestMonths]="9"
        [parentParagraphType]="ParentParagraphType.SLOWDOWN_MYOPIA_MYOPIC"></app-parent-paragraph>
      }

      <app-parent-paragraph [retestMonths]="9"
        [parentParagraphType]="ParentParagraphType.WHAT_NEXT_MYOPIC"></app-parent-paragraph>
      <app-parent-paragraph [retestMonths]="9"
        [parentParagraphType]="ParentParagraphType.FURTHER_RESOURCES"></app-parent-paragraph>
      }

      <app-credits class="w-full"></app-credits>
    </div>
  </p-card>
</div>
<div class="max-w-comfort"></div>